export default "__VITE_ASSET__reE5heZK__"